import _ from 'underscore';

import ActionList from '../../actionList';
import Config from '../../config';
import Module from '../../core/module';
import ScheduleFormModule from '../schedule/form';
import ScheduleTemplatesModule from '../schedule/templates.list';
import Task from '../../model/task';

import { promisify, } from '../../utils/promisify';
import { delay, rejectOn } from '../../utils/promisify';
import { error } from '../../ui/messages'
import { handle } from '../../service/messages';  
import { get, del, } from '../../http/api';
import { ask, } from '../../utils/popups';
import { beginLock, endLock } from '../../loader';
import { save as saveTask } from '../../model/task.utils';
import { fmt } from '../../utils/date';

// todo: module stop!

const BACK = 'back--from-task';

export default Module.extend( {

    initialize(options = {}) {
        Module.prototype.initialize.call( this, options );

        const actionDefs = {
            
            ok: {
                handler: () =>
                    save( this ).then( () => close( this ) ),
        
                disabled: () =>
                    this.options.isRoot || 
                    !this.TaskForm || 
                    !this.TaskForm.hasDiff( { fields: this.options.fields } ),
            },
    
            apply: {
                handler: () =>
                    save( this ),
        
                disabled: () =>
                    !this.TaskForm || !this.TaskForm.hasDiff( { fields: this.options.fields } ),
            },
        
            rollback: {
                handler: () => {
                    this.TaskForm.rollback();
                    this.bind( this.model );
                },
        
                disabled: () =>
                    !this.TaskForm || !this.TaskForm.hasDiff( { fields: this.options.fields } ),
            },

            close: {
                handler: () =>
                    close( this ),

                disabled: () =>
                    this.options.isRoot,
            },
        };
        
        this.options.actions = new ActionList( actionDefs );
    },

    template: 'jst/module.tasks.form',

    url() {
        return `task/${this.model.id}`;
    },

    open(taskModel) {
        const fetchingTask = taskModel instanceof Task
            ? Promise.resolve( taskModel )
            : Task.byId( taskModel )

        return fetchingTask.then( taskModel => {
            const objId = taskModel.get( 'service_object_id' );
            const layerId = taskModel.get( 'service_object_layer_id' );
            if (objId)
                this.object = {
                    attrs: [],
                    loaded: false,
                    failed: false,
                },
    
                get( `/datatables/${layerId}/features/${objId}?taskId=${taskModel.id}` ).mapsurfer()
                    .map( response => response.feature )
                    .chain( () => get( `/datatables/${layerId}` ).mapsurfer() )
                    .map( response => response.attributes )
                    .filter( field => field.view )
                    .map( ({ nameDb, title, type }, index, fields, response, obj) => {
                        const arrayTypes = [
                            'systemcluster[]', 'systemorg[]', 'systemuser[]', 'systemrole[]',
                            'systemtasktype[]', 'systemtaskpriority[]'
                        ];

                        const refTypes = [
                            'systemcluster', 'systemorg', 'systemuser', 'systemrole',
                            'systemtasktype', 'systemtaskpriority'
                        ];

                        const value = obj[nameDb];
                        if (arrayTypes.includes( type ))
                            return {
                                name: title,
                                value: value == null ? value : value
                                    .map( ({ refValue, refValueName }) => `${refValueName} (#${refValue})` )
                                    .join( ', ' )
                            };

                        if (type === 'reference' || refTypes.includes( type ))
                            return {
                                name: title,
                                value: value == null ? value : `${value.refValueName} (#${value.refValue})`
                            };

                        if (type === 'date')
                            return {
                                name: title,
                                value: fmt( value, 'DD.MM.YYYY' )
                            };
                            
                        if (type === 'dateTime')
                            return {
                                name: title,
                                value: fmt( value, 'DD.MM.YYYY HH:mm' )
                            };
                            
                        return { name: title, value };
                    } )
                    .execute()
                    .then( attrs => this.object.attrs.push( ...attrs ) )
                    .then( () => this.object.loaded = true, (e, x) => {
                        console.error( e, x );
                        this.object.failed = true;
                    } )
                    .then( () => this.Card.render() );
    
            return this.bind( taskModel );
        } );
    },

    start() {
        if (this.Map) {
            this.listenTo( this.TaskForm.Assignee, 'points', 
                points => this.Map.setLocations( points ) );
            this.listenTo( this.TaskForm.Assignee, 'assignee:dropdown-hide', 
                // clear filtered locations after 250ms delay
                // but don't clear if user clicks on map in these 250ms
                points => Promise.race( [rejectOn( 'assignee:click', this.Map ), delay( 250 )] )
                    .then( () => this.Map.clearLocations() ) );
            this.listenTo( this.Map, 'assignee:assign',
                ({ user }) => this.TaskForm.model.assign( user ) );
        }

        // AS IN /module/schedule/templates.form.js

        const org = this.options.organizations.toJSON()
            .find( org => org.id == this.model.get( 'organization_id' ) );
        const type = this.options.types.toJSON()
            .find( type => type.id == this.model.get( 'type_id' ) );
        const isTypeAvailable = type
            ? type.role_ids == null || type.role_ids.includes( Config.role() ) || type.role_ids.includes( +Config.role() )
            : false;
        if (org && isTypeAvailable)
            this.TaskForm.focus();
        else
            // task of deleted org/cluster or unavailable type
            this.TaskForm.disable(),
            this.Schedule && this.Schedule.disable(),
            this.Map && this.Map.disable(),
            this.Comments.disable();

        if (this.model.capabilities_)
            if (!this.model.capabilities_.edit && !this.model.capabilities_.update_point)
                this.Map && this.Map.disable();

        return this;
    },

    stop() {
        this.stopListening( this.TaskForm.Assignee );
        this.Map && this.stopListening( this.Map );
        
        this.options.actions.clearDependencies( this.model );

        return this;
    },

    onBind(model, previousModel) {
        if (previousModel)
            this.options.actions.clearDependencies( previousModel );
        this.options.actions.depend( model, 'change' );
    },

    serialize() {
        return {
            ...this.model.toJSON(),
            date: this.model.get( 'date' ),
            capabilities: this.model.capabilities_,
            object: this.object,
        };
    },

    [Module.event( 'Map:map:click' )](location) {
        if (!this.Map.disabled())
            this.model.set( 'location', location );
    },

    [Module.event( ':schedule:edit' )]({ id }) {
        return this.trigger( ScheduleFormModule.POPUP_EDIT, 
            // pass id only to force Schedule.byId in Form
            id );
    },

    [Module.event( ':schedule:delete' )]({ id }) {
        ask( 'schedule::modal delete schedule - confirmation text', 
            'schedule::modal delete schedule - title', 
            'actions::yes', 
            'actions::no',
            () => del( `/timetables/${id}` )
                .blocking( this ).cerebellum()
                .execute() )
            .then( () => {
                this.model.get( 'schedule' ).deleted = true;
                return this.Schedule.render();
            } );
    },

    [Module.event( ':schedule:templates' )]({ id }) {
        return this.trigger( ScheduleTemplatesModule.POPUP, 
            // pass id only to force Schedule.byId in Template List
            id );
    },

}, {

    BACK,

} );

function create(form) {
    return promisify( new Task( form.model.toJSON() ).save() )
        .then( resp => resp.newsId )
        .then( id => form.model.set( 'id', id ) )
}

function save(layout) {
    const form = layout.TaskForm;
    const { result, messages } = form.validate();
    if (!result)
        return Promise.reject( handle( form, error( messages[0] /* [text, field] */ ) ) );

    const op = !form.model.id ? create( form ) : saveTask( layout );

    return beginLock( this ), op
        .then( response => new Task( response, { parse: true } ) )
        // .then( model => form.model.set( model.toJSON() ) )
        // make form "remember" changes
        // .then( () => form.commit() )
        // force toolbar to update itself (firing event on its actionList)
        // .then( () => actions.trigger( 'update' ) )
        // .then( postpone )
        // .then( () => form.focus() )
        // todo don't use render here
        .then( updatedModel => layout.bind( updatedModel ) )
        // need to call update here because there is pending
        // onBindDone() for TaskForm when onBind called
        .finally( () => endLock( this ) )
        .finally( () => layout.options.actions.trigger( 'update' ) )
        .catch( message => {
            handle( form, error( message ) );
            throw message;
        } );
        ;
}

function close(layout) {
    layout.trigger( BACK );
}






// WEBPACK FOOTER //
// ./src/js/module/tasks/form.js